/* eslint-disable indent */
/* eslint-disable id-length */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable max-len */
import * as React from 'react';
import './index.scss';
import { Provider } from 'react-redux';
import store, { useAppSelector } from './../../toolkit';
import Serve from './../../serve';
// import PopInvite from './hooks/PopInvite';
import PopSuccess from './hooks/PopSuccess/index';
import PopSuccessNew from './hooks/PopSuccessNew/index';
import PopAward from './hooks/PopAward';
import Share from './hooks/Share/index';
// import Detail from './hooks/Detail/index';
import DetailNew from './hooks/DetailNew/index';
import InviteInfo from './hooks/InviteInfo/index';
import { HYToast, HYLogin } from '@hy-hybrid/kiwi-js-sdk';
import PopWechat from './hooks/PopWechat';
import Head from './hooks/Head';
import { Loading } from '@huyafed/comp';
import StaticHead from './hooks/Head/StaticHead';
import {
  reportFuc,
  formatDate,
  formatDate3,
  getURLParam,
  ruleText,
} from './../../utils';
import openApp from '@huyafed/openapp';
import classNames from 'classnames';
import getAb from './hooks/ABtest';
import { SafeHtml } from '@huyafed-security/safe-html-react'
// import VConsole from 'vconsole';

const isProd = process.env.TIGER_BUILD_ENV === 'pre';
if (!isProd) {
  // new VConsole();
}

const { showToast } = HYToast;
const { showLogin } = HYLogin;
const { useState, useEffect, useMemo } = React;

const Index = () => {
  const { preLogin, isLogin, isDebug, isApp } = useAppSelector(
    state => state.base,
  );
  const [ruleCount, setRuleCount] = useState(7);
  const [status, setStatus] = useState(0); // 自身状态, -2非app, -1未登录, 0加载中, 1正常, 2非目标用户
  const [iOld, setiOld] = useState(1); // 新旧版本，0旧版，1新版
  const [tTotal, setTTotal] = useState<any>({
    lExp: 0,
    lPoint: 0,
    lCash: 0,
    lValue: 0,
    lAwardTime: 0,
    sReason: 0,
    vGift: {
      value: [],
    },
  }); // 总奖励
  const [tCurrentTotal, settCurrentTotal] = useState<any>({
    lExp: 0,
    lPoint: 0,
    lCash: 0,
    lValue: 0,
    lAwardTime: 0,
    sReason: 0,
    vGift: {
      value: [],
    },
  }); // 当前邀请总奖励
  const [popTotal, setPopTotal] = useState<any>({
    lExp: 0,
    lPoint: 0,
    lCash: 0,
    lValue: 0,
    vGift: {
      value: [],
    },
  });
  const [iInvedType, setiInvedType] = useState(0); // 被邀请人类型
  const [iInvCount, setIInvCount] = useState(0); // 已邀请人数量
  const [iCurrentInvCount, setiCurrentInvCount] = useState(0); // 当前已邀请人数量
  const [time, setTime] = useState(['', '']); // 活动时间
  const [ruleTime, setRuleTime] = useState(['', '']); // 规则时间
  const [invCode, setInvCode] = useState({ 1: '', 2: '', 3: '', 4: '' }); // 邀请码
  const [mInved, setInved] = useState({ 0: 0, 1: 0, 2: 0 }); // 邀请人数量
  const [users, setUsers] = useState([]); // 已邀请用户
  const [balance, setBalance] = useState(0); // 现金余额
  const [tNewItem, setNewItem] = useState(null); // 新用户奖励配置
  // const [tNewItemVp,setNewItemVp] = useState(0);
  // const [tBackItemVp,setBackItemVp] = useState(0);
  const [tBackItem, setBackItem] = useState(null); // 回归用户奖励配置
  const [qrcodeData, setQrcodeData] = useState(
    JSON.stringify({
      newCash: 0,
      newTotal: 0,
      backCash: 0,
      backTotal: 0,
    }),
  ); // 扫码页面需要的现金和礼包数据
  const [showPop, setShowPop] = useState(false); // 奖励弹窗
  // const [showInvite, setShowInvite] = useState(false); // 没邀请人去提现弹窗
  const [showSuccess, setShowSuccess] = useState(false); // 邀请成功弹窗
  const [showShare, setShowShare] = useState(0); // 分享面板
  const [showWechat, setShowWechat] = useState(false); // 微信分享面板
  const [showDetail, setShowDetail] = useState(false); // 详情面板
  const [abbg, setabbg] = useState(0);
  const [newCash, setnewCash] = useState(0);
  // 查现金余额
  const checkBalance = () => {
    Serve.checkBalance().then(rsp => {
      if (rsp.code === 0) {
        setBalance(rsp.data.lBalance + rsp.data.lFrozenBalance);
      } else {
        showToast({
          message: rsp.errorMessage,
        });
      }
    });
  };
  const renderAbbg = async () => {
    const abtest = await getAb();
    if (abtest != undefined) {
      setabbg(abtest);
    }
  };
  useEffect(() => {
    // 因为islogin和tid获取都是异步的，所以加多个判断
    if (preLogin && !isLogin) return;
    // 非App环境
    if (!isApp) {
      reportFuc(
        'sys/pageview/ldx/mainPage',
        '系统/页面展示/老带新/主页面曝光',
        { state: 2, channel: getURLParam('channel') },
      );
      setStatus(-2);
      return;
    }
    // 未登录则拉起登录
    if (!isLogin) {
      reportFuc(
        'sys/pageview/ldx/mainPage',
        '系统/页面展示/老带新/主页面曝光',
        { state: 3, channel: getURLParam('channel') },
      );
      showLogin({ type: 1 });
      setStatus(-1);
      return;
    }
    Serve.getFriendInvitationInfo(1).then((rsp: any) => {
      if (rsp.code === 0 && rsp.data.iReturnCode === 0) {
        const resp = rsp.data;
        setStatus(1);
        // setiOld(resp.iV3Group);
        setiInvedType(resp.iInvedType);
        // 对象转数组
        const newItem = resp.tDefaultAward.tNewItem.mDayCash.value;

        console.log('奖励详情: ', resp.tDefaultAward);
        const newItemArray: any = [];
        let newCash = 0;
        Object.keys(newItem).map(item => {
          newItemArray.push({
            day: item,
            value: newItem[item],
          });
          newCash += newItem[item];
        });
        setNewItem(newItemArray);
        setnewCash(newCash);

        try {
          newItemArray[0].value += resp.tDefaultAward.tNewItem.lPrice;
        } catch (error) {
          console.log('新人礼包价值错误', error);
        }

        const backItem = resp.tDefaultAward.tBackItem.mDayCash.value;
        const backItemArray: any = [];
        let backCash = 0;
        Object.keys(backItem).map(item => {
          backItemArray.push({
            day: item,
            value: backItem[item],
          });
          backCash += backItem[item];
        });
        console.log('backItemArray: ', backItemArray);

        try {
          backItemArray[0].value += resp.tDefaultAward.tBackItem.lPrice;
        } catch (error) {
          console.log('回归礼包价值错误', error);
        }

        setBackItem(backItemArray);
        setQrcodeData(
          JSON.stringify({
            newCash,
            newTotal: resp.tDefaultAward.tNewItem.lPrice,
            backCash,
            backTotal: resp.tDefaultAward.tBackItem.lPrice,
          }),
        );

        // setiOld(1)
        // setInvCode(resp.mInvCode.value)
        setIInvCount(resp.iInvCount);
        setiCurrentInvCount(resp.iCurrentInvCount);
        // 邀请人数非0则请求提现余额
        if (resp.iInvCount > 0) checkBalance();
        setTTotal({
          ...resp.tTotal,
          lValue: resp.tTotal.lValue + resp.tTotal.lCash,
        });

        settCurrentTotal({
          ...resp.tCurrentTotal,
          // lValue: resp.tCurrentTotal.lValue + resp.tCurrentTotal.lCash,
          lValue: resp.tCurrentTotal.lValue,
        });

        setPopTotal({ ...resp.tDefaultAward.tNewItem });
        setShowSuccess(!!resp.iToast);
        // setShowSuccess(true)
        setInved(resp.mInved.value);
        setUsers(resp.vInvedUserStatus.value);
        setTime([
          formatDate(resp.lStartTime * 1000),
          formatDate(resp.lEndTime * 1000),
        ]);
        setRuleTime([
          formatDate3(resp.lStartTime * 1000),
          formatDate3(resp.lEndTime * 1000),
        ]);
        reportFuc(
          'sys/pageview/ldx/mainPage',
          '系统/页面展示/老带新/主页面曝光',
          { state: resp.iInvCount > 0 ? 1 : 0, channel: getURLParam('channel') },
        );
      } else {
        showToast({
          message: rsp.code !== 0 ? '网络错误!' : '无参与活动资格!',
        });
        if (rsp.data.iReturnCode === 2) {
          setStatus(2);
          reportFuc(
            'sys/pageview/ldx/errorpage',
            '系统/页面展示/老带新/不可参与托底页曝光',
            {},
          );
        }
        if (!rsp.code) setTime([
            formatDate(rsp.data.lStartTime * 1000),
            formatDate(rsp.data.lEndTime * 1000),
          ]);
      }
    });
  }, [isLogin, isApp]);
  useEffect(() => {
    console.log('屏幕高度', window.screen.height);
    renderAbbg();
    if (showShare && !invCode['1']) {
      Serve.getFriendInvCode().then(rsp => {
        const resp = rsp.data;
        setInvCode(resp.mInvCode.value);
      });
    }
  }, [showShare]);
  // 非目标用户
  const notAuthority = useMemo(() => {
    if (iOld === 0) {
      return (
        <div className="notAuthority">
          <i />
          <p>很抱歉，本活动仅限老用户参与</p>
          <p>请在注册7天后再来吧</p>
        </div>
      );
    } else {
      return (
        <div className="notAuthority">
          <i />
          <p>本期活动仅限受邀用户参与</p>
          <p>先去看看直播吧</p>
        </div>
      );
    }
  }, [iOld]);
  const hasInvite = useMemo(
    () =>
      status === 1 &&
      iInvCount > 0 &&
      iOld !== -1 && (
        <InviteInfo
          iOld={iOld === 0}
          isDebug={isDebug}
          iInvCount={iInvCount}
          tTotal={tTotal}
          users={users}
          balance={balance}
          inved={mInved['2'] || 0}
          // setShowPop={setShowInvite}
          setShowDetail={setShowDetail}
          setShowShare={idx => setShowShare(idx)}
        />
      ),
    [status, iInvCount, tTotal, isDebug, mInved, users, balance, iOld],
  );
  return (
    <div className="index">
      {/* <a onClick={() => window.location.reload()}>刷新(临时)</a> */}
      {status === 0 && <Loading diameter={10} type={1} color={'#B5734C'} />}
      {iOld !== -1 && !(status === -1 || status === -2) && (
        <Head
          abbg={abbg}
          newCash={newCash}
          iOld={iOld !== 1}
          // sTime={time[0] + '-' + time[1]}
          sTime={'即日起' + '-' + time[1]}
          status={status}
          toShare={() => {
            if (status === 1) {
              // reportFuc(
              //   'usr/click/ldx/maininvitation',
              //   '用户/点击/老带新/主邀请按钮点击',
              //   { user_type: iInvedType }
              // );
              setShowShare(1);
            }
          }}
          toRule={() => {
            setShowPop(true);
            reportFuc(
              'usr/click/ldx/question',
              '用户/点击/老带新/问号点击',
              {},
            );
          }}
        />
      )}
      {
        /* 未登录或非app环境 */
        (status === -1 || status === -2) && (
          <StaticHead>
            <div
              className={classNames('toLogin', {
                yes: isApp && getURLParam('hdtd') !== '1',
                no: !isApp,
                hdtd: getURLParam('hdtd') === '1',
              })}
              onClick={() => {
                if (isApp) {
                  showLogin({ type: 1 });
                } else {
                  openApp({
                    url: encodeURIComponent(
                      getURLParam('debug') === '1'
                        ? `https://test-hd.huya.com/h5/202111invite/test/index.html?debug=1&hideShareButton=1&channel=${
                            getURLParam('channel') + '-jumpin'
                          }`
                        : `https://hd.huya.com/h5/202111invite/index.html?hideShareButton=1&channel=${
                            getURLParam('channel') + '-jumpin'
                          }`,
                    ),
                    key: 'ldx',
                  });
                }
              }}
            >
              {getURLParam('hdtd') === '1' && <div className="hdtd-btn" />}
            </div>
          </StaticHead>
        )
      }
      {status === 2 && (
        <StaticHead notA={true}>
          <div className="notAA"></div>
        </StaticHead>
      )}
      {/* 非目标用户 */}
      {status === 2 && notAuthority}
      {hasInvite}
      {
        // 相关静态素材文案
        useMemo(
          () =>
            status === 1 && (
              // (
              <>
                <div
                  className={classNames('how', {
                    iOld: iOld !== 1,
                  })}
                />
                <div
                  className={classNames('award', {
                    iOld: iOld !== 1,
                  })}
                >
                  {iOld === 1 && tNewItem && tBackItem && (
                    <>
                      {[tNewItem, tBackItem].map((listItem: any, idx) => (
                        <ul
                          className={classNames('award-ul', {
                            new: !!!idx,
                            back: !!idx,
                          })}
                          key={idx}
                        >
                          {listItem.map((item, index) => (
                            <li key={index}>
                              <div className={`money num${index}`}>
                                {(item.value / 100)
                                  .toFixed(1)
                                  .toString()
                                  .split('')
                                  .map((moneyItem, id) => (
                                    <i
                                      className={`num-${
                                        moneyItem == '.' ? 'dot' : moneyItem
                                      }`}
                                      key={id}
                                    ></i>
                                  ))}
                                <i className="yuan" />
                              </div>
                              <div className="text">
                                {['新', '回归'][idx]}朋友
                                <span className="text-1">看直播</span>
                                <span className="text-2">{item.day}</span>天
                              </div>
                            </li>
                          ))}
                        </ul>
                      ))}
                      <ul className={classNames('award-ul', { old: true })}>
                        <li>
                          <div className="text">
                            老朋友<span className="text-1">当天首次看直播</span>
                          </div>
                        </li>
                      </ul>
                    </>
                  )}
                </div>
                <div className={classNames('rule')}>
                  <h1 className="title" />
                  <ul>
                    {ruleText(!iOld, ruleTime[1]).map(
                      (item, idx) =>
                        idx < ruleCount && <li key={idx}><SafeHtml html={item} /></li>,
                    )}
                  </ul>
                  <div
                    className="ruleBtn"
                    onClick={() => setRuleCount(ruleCount === 7 ? 100 : 7)}
                  >
                    {ruleCount === 7 ? '展开全部' : '收起'}
                  </div>
                </div>
              </>
            ),
          [status, ruleTime, ruleCount, iOld, tNewItem, tBackItem],
        )
      }
      {
        // 奖励弹窗
        useMemo(
          () =>
            showPop && (
              <PopAward close={() => setShowPop(false)} tTotal={popTotal} />
            ),
          [showPop, popTotal],
        )
      }

      {
        // 邀请成功弹窗
        useMemo(
          () =>
            showSuccess &&
            iOld !== -1 &&
            (iOld === 0 ? (
              <PopSuccess
                close={() => setShowSuccess(false)}
                showAward={() => {
                  setShowSuccess(false);
                  setShowDetail(true);
                }}
              />
            ) : (
              <PopSuccessNew
                close={() => setShowSuccess(false)}
                tTotal={tCurrentTotal}
                iInvCount={iCurrentInvCount}
                // balance={balance}
                showAward={() => {
                  setShowSuccess(false);
                  setShowDetail(true);
                }}
                showShare={() => {
                  setShowSuccess(false);
                  setShowShare(1);
                }}
              />
            )),
          [showSuccess, iOld, tCurrentTotal, iCurrentInvCount],
        )
      }
      {
        // 微信复制弹窗
        useMemo(
          () => showWechat && <PopWechat close={() => setShowWechat(false)} />,
          [showWechat],
        )
      }
      {
        // 分享面板弹窗
        useMemo(
          () => (
            <Share
              iOld={iOld !== 1}
              status={showShare}
              set={setShowShare}
              showWechat={() => setShowWechat(true)}
              inviteCode={invCode}
              // awardConfig={awardConfig}
              qrCodeData={qrcodeData}
            />
          ),
          [iOld, showShare, invCode, qrcodeData],
        )
      }
      {
        // 邀请详情弹窗
        useMemo(
          () => (
            // iOld === 0 ? (
            //   <Detail
            //     status={showDetail}
            //     set={setShowDetail}
            //     isDebug={isDebug}
            //     inved={mInved['2'] || 0}
            //   />
            // ) : (
            <DetailNew
              status={showDetail}
              set={setShowDetail}
              isDebug={isDebug}
              inved={mInved['2'] || 0}
            />
          ),
          [showDetail, isDebug, mInved, iOld],
        )
      }
    </div>
  );
};

export default (): React.ReactNode => (
  <Provider store={store}>
    <Index />
  </Provider>
);
